<p>attribute-editor works!</p>
